import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { MerchantUserRegistrationFormComponent } from './components/merchant-user-registration-form/merchant-user-registration-form.component';
import { MerchantUserRegistrationRoutingModule } from './merchant-user-registration-routing.module';
import { MerchantUserRegistrationComponent } from './merchant-user-registration/merchant-user-registration.component';

@NgModule({
  declarations: [
    MerchantUserRegistrationComponent,
    MerchantUserRegistrationFormComponent,
  ],
  exports: [MerchantUserRegistrationFormComponent],
  imports: [CommonModule, MerchantUserRegistrationRoutingModule, SharedModule],
})
export class MerchantUserRegistrationModule {}
